module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-background-ed54b348a87d0fb7459196a8b1960c05.png";